import { gql } from "@apollo/client";


export const VALIDATE_PACIENTE_PP = gql`
query validatePacientePP(
    $idPaciente: Int!
 ){
    validatePacientePP(
        idPaciente: $idPaciente,
    )
}
`;